<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="side-menu"
        transform="translate(-32, -349)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g id="Group-9" transform="translate(32, 348)">
          <g
            id="account_circle_FILL1_wght400_GRAD0_opsz48"
            transform="translate(0, 1)"
          >
            <path
              id="Shape"
              d="M2.84,12.5 C3.68,11.9666667 4.51,11.5633333 5.33,11.29 C6.15,11.0166667 7.04,10.88 8,10.88 C8.96,10.88 9.85333333,11.0166667 10.68,11.29 C11.5066667,11.5633333 12.34,11.9666667 13.18,12.5 C13.7666667,11.78 14.1833333,11.0533333 14.43,10.32 C14.6766667,9.58666667 14.8,8.81333333 14.8,8 C14.8,6.06666667 14.15,4.45 12.85,3.15 C11.55,1.85 9.93333333,1.2 8,1.2 C6.06666667,1.2 4.45,1.85 3.15,3.15 C1.85,4.45 1.2,6.06666667 1.2,8 C1.2,8.81333333 1.32666667,9.58666667 1.58,10.32 C1.83333333,11.0533333 2.25333333,11.78 2.84,12.5 Z M8,8.6 C7.22666667,8.6 6.57666667,8.33666667 6.05,7.81 C5.52333333,7.28333333 5.26,6.63333333 5.26,5.86 C5.26,5.08666667 5.52333333,4.43666667 6.05,3.91 C6.57666667,3.38333333 7.22666667,3.12 8,3.12 C8.77333333,3.12 9.42333333,3.38333333 9.95,3.91 C10.4766667,4.43666667 10.74,5.08666667 10.74,5.86 C10.74,6.63333333 10.4766667,7.28333333 9.95,7.81 C9.42333333,8.33666667 8.77333333,8.6 8,8.6 Z M8,16 C6.88,16 5.83333333,15.79 4.86,15.37 C3.88666667,14.95 3.04,14.3766667 2.32,13.65 C1.6,12.9233333 1.03333333,12.0733333 0.62,11.1 C0.206666667,10.1266667 0,9.08666667 0,7.98 C0,6.88666667 0.21,5.85333333 0.63,4.88 C1.05,3.90666667 1.62333333,3.06 2.35,2.34 C3.07666667,1.62 3.92666667,1.05 4.9,0.63 C5.87333333,0.21 6.91333333,0 8.02,0 C9.11333333,0 10.1466667,0.21 11.12,0.63 C12.0933333,1.05 12.94,1.62 13.66,2.34 C14.38,3.06 14.95,3.90666667 15.37,4.88 C15.79,5.85333333 16,6.89333333 16,8 C16,9.09333333 15.79,10.1266667 15.37,11.1 C14.95,12.0733333 14.38,12.9233333 13.66,13.65 C12.94,14.3766667 12.0933333,14.95 11.12,15.37 C10.1466667,15.79 9.10666667,16 8,16 Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconUser",
  props: {
    size: {
      type: String,
      default: "1rem",
    },
  },
};
</script>
